var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"existing-info-message"},[_c('p',[_c('strong',[_vm._v("✓ "+_vm._s(_vm.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }